export type ColorTheme = "LIGHT" | "DARK";

export const PROD_HOSTNAME = "on-bible.com";

// On production the whole site stays light; the color theme toggle only affects
// lesson / lesson-editor surfaces locally. On any other host (staging, localhost)
// the toggle keeps painting the whole app, which is convenient for testing dark mode.
export const resolveSiteColorTheme = (appColorTheme: ColorTheme, hostname: string): ColorTheme =>
	hostname === PROD_HOSTNAME ? "LIGHT" : appColorTheme;
